<template>
    <div class="view login">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <el-card class="box-card">
                        <div slot="header" class="text-left">
                            <h3>Set your new password</h3>
                        </div>
                        <form class="form-signin" @submit.prevent="submit">
                            <div v-if=errorMessage>
                                <b-alert show variant="warning">{{ errorMessage }}</b-alert>
                            </div>
                            <div :class="{ 'hasError': $v.password.$error }">
                                <label for="inputEmail" class="sr-only">Password</label>
                                <input v-model=password type="password" class="form-control" placeholder="Password" required autofocus>
                            </div>
                            <div class="error" v-if="!$v.password.minLength">Password must have at least {{ $v.password.$params.minLength.min }} letters.</div>
                            <div :class="{ 'hasError': $v.repeatPassword.$error }">
                                <label for="inputEmail" class="sr-only">Repeat Password</label>
                                <input v-model=repeatPassword type="password" class="form-control" placeholder="Repeat your password" required autofocus>
                            </div>
                            <div class="error" v-if="!$v.repeatPassword.sameAsPassword">Passwords must be identical.</div>
                            <button class="btn btn-lg btn-primary btn-block mt-10" type="submit">Reset password</button>
                        </form>
                    </el-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { required, sameAs, minLength } from 'vuelidate/lib/validators'

export default {
    data () {
        return {
            password: '',
            repeatPassword: '',
            errorMessage: null
        }
    },

    validations: {
        password: {
            required,
            minLength: minLength(6)
        },
        repeatPassword: {
            sameAsPassword: sameAs('password')
        }
    },

    methods: {
        submit () {
            this.errorMessage = null

            // All validations passed, so send invite request to token service
            this.$auth.resetPassword(this.$route.query.email, this.$route.query.token, this.password)
                .then(response => {
                    if (response.status === 200) {
                        this.$router.push({ path: '/login' })
                    } else {
                        this.errorMessage = 'Something went wrong'
                    }
                })
                .catch(error => {
                    this.errorMessage = 'Something went wrong'
                    console.log(error)
                })
        }
    }
}
</script>

<style lang="scss">
.reset-password-page {
    .card-header {
        background-color: #fff;
    }
    .form-signin {
    width: 100%;
    max-width: 330px;
    padding: 15px;
    margin: 0 auto;
    }
    .form-signin .checkbox {
    font-weight: 400;
    }
    .form-signin .form-control {
    position: relative;
    box-sizing: border-box;
    height: auto;
    padding: 10px;
    font-size: 16px;
    }
    .form-signin .form-control:focus {
    z-index: 2;
    }
    .form-signin input[type="email"] {
    margin-bottom: -1px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
    }
    .form-signin input[type="password"] {
    margin-bottom: 10px;
    margin-top: 10px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    }
}
</style>
